import { Handshake, Handlove, Handpeace, Heart, Lightbulb, Plant } from '../../assets/team';

const aboutFingoData = {
  title: 'Así es ser parte de Fingo',
  description: 'En Fingo somos un equipo que disfruta trabajar en conjunto, en un ambiente abierto, cercano y colaborativo. '
  + 'Creemos que los logros se construyen en conjunto y que cada persona aporta algo único para que las cosas pasen. '
  + '\nPor eso, más allá de lo que hacemos, lo que realmente nos distingue es cómo lo vivimos en el día a día.',
  staffComments: [
    {
      id: 0,
      text: '“En Fingo puedo desarrollarme y expresarme con libertad, lo que hace que trabajar en equipo sea fácil y agradable.”',
      icon: Handpeace,
    },
    {
      id: 1,
      text: '“Combinamos autonomía y colaboración: cada persona aporta su experiencia y siempre hay apoyo mutuo.”',
      icon: Lightbulb,
    },
    {
      id: 2,
      text: '“La flexibilidad y el teletrabajo me permiten equilibrar mi vida personal y profesional.”',
      icon: Plant,
    },
    {
      id: 3,
      text: '“Todos se apoyan sin dudarlo; juntos sacamos adelante cualquier desafío.”',
      icon: Handlove,
    },
    {
      id: 4,
      text: '“Fingo fomenta la innovación y el aprendizaje; cada día es motivador gracias a la energía del equipo.”',
      icon: Heart,
    },
    {
      id: 5,
      text: '“La comunicación abierta y el respeto mutuo hacen que trabajar aquí sea un placer.”',
      icon: Handshake,
    },
  ],
  videos: [
    { id: 0, src: 'team-1.mp4' },
    { id: 1, src: 'team-2.mp4' },
    { id: 2, src: 'team-3.MOV' },
    { id: 3, src: 'team-4.mp4' },
    { id: 4, src: 'team-5.mp4' },
    { id: 5, src: 'team-7.mp4' },
    { id: 6, src: 'team-6.mp4' },
  ],
  missionTitle: '🤝 Nuestra misión',
  missionText: 'En Fingo nuestra misión es facilitar el acceso al financiamiento a través de soluciones tecnológicas simples y humanas. '
  + '\nSabemos que el sistema financiero tradicional muchas veces no las escucha, por eso buscamos emparejar la cancha con herramientas digitales eficientes y un equipo cercano que entiende sus necesidades.'
  + 'Creemos en una tecnología al servicio de las personas, combinando innovación, agilidad y empatía para dar tranquilidad financiera a quienes más lo necesitan.',
  visionTitle: '🌎 Nuestra visión',
  visionText: 'En Fingo queremos construir la red de financiamiento más cercana y eficiente de Latinoamérica, transformando la forma en que las empresas acceden a capital y oportunidades. '
  + 'Aspiramos a liderar un nuevo estándar financiero: más transparente, democrático y simple. '
  + 'Nuestro objetivo es ser el referente en soluciones que escalan con tecnología y generan un impacto real, impulsando el crecimiento sostenible de miles de empresas en la región.',
};

export default aboutFingoData;
